import { render, staticRenderFns } from "./finish_add.vue?vue&type=template&id=3c741772&scoped=true&"
import script from "./finish_add.vue?vue&type=script&lang=js&"
export * from "./finish_add.vue?vue&type=script&lang=js&"
import style0 from "./finish_add.vue?vue&type=style&index=0&id=3c741772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c741772",
  null
  
)

export default component.exports